<div class="container">
  @for (plan of plans(); track plan.id) {
    <div class="plan-card">
      <div class="card-head">
        <div class="title">
          {{plan.product.name}}
        </div>
        <div class="description">
          for {{plan.interval_count }} {{plan.interval_count === 1 ? plan.interval : plan.interval + 's'}}
        </div>
      </div>

      <div class="card-body">
        <div class="price">
          ${{ !(plan.monthly % 100) ? plan.monthly / 100 : (plan.monthly / 100).toFixed(2)}} / month
        </div>


          <div class="price-hint">
            @if (plan.saveString) {
              {{plan.saveString}}
            } @else {
              &nbsp;
            }
          </div>

      </div>

      <div>
      <button matButton="filled" class="button-regular w-100 pb-12" (click)="select(plan.product.id)" [disabled]="plan.product.id === activePlanId()">
        {{plan.product.id === activePlanId() ? 'Current Plan' : 'Select'}}
      </button>

      </div>

    </div>
  }

</div>
